import { CGAHierarchyReport } from './CGAHierarchyReport';
import { Content, Header, Page } from '@backstage/core-components';

/**
 * Page component for displaying the CGA Hierarchy Report.
 * Renders a page with header and the hierarchy report view.
 * @returns The CGA Hierarchy Report page component.
 */
export const CGAHierarchyReportPage = () => {
  return (
    <Page themeId="home">
      <Header
        style={{ whiteSpace: 'nowrap' }}
        title="CGA Hierarchy Report"
        subtitle="View and generate hierarchy report for reporting levels"
      />
      <Content>
        <CGAHierarchyReport />
      </Content>
    </Page>
  );
};
